import { useSelector } from "react-redux";
import { RootState } from "../state/store";
import { AdminRole } from "../types/constants.types";

export function useCurrentRole() {
  return useSelector((state: RootState) => state.auth.role);
}

export function useCurrentEmail() {
  return useSelector((state: RootState) => state.auth.email);
}

export function useIsKioskOwner(): boolean {
  const role = useCurrentRole();
  return role?.toUpperCase() === AdminRole.KIOSK_OWNER;
}
